<template>
    <div id="addressOptions">
        <!-- labels: 1144-1145 -->
        <div id="allAddressesBox">
            <table class="table table-condensed">
                <tbody>
                    <tr v-if="isLoadingAddresses">
                        <td>
                            <img src='/layouts/main/styles/images/spinner.gif' /> Loading Addresses
                        </td>
                        <td></td>
                        <td></td>
                    </tr>
                    <template v-else-if="addressOptions.length">
                        <tr v-for="option in addressOptions" v-bind:key="option.ID" :id="option.ID" :class="isHighlighted(option.ID)" @click="selectAddress(option, mode)">
                            <td>
                                <div v-if="isAddressSameAsShipping(option.ID) && mode === 'billing'">
                                    <strong>{{ labels[1334] }}</strong><!-- Label: same as shipping -->
                                </div>
                                <div v-else>
                                    <div v-html="breakCharsToBr(option.ADDRESS)"></div>
                                    {{ option.CITY }}, {{ option.STATE }} {{ option.POSTAL }}
                                    <br />
                                    {{ option.COUNTRY }}
                                </div>
                            </td>
                            <td>
                                <!-- <a href="##" class="small" id="#id#">{{ labels[1001] }} edit </a> -->
                            </td>
                            <td>
                                <button v-if="!isSelected(option.ID)" type="button" class="btn btn-default btn-xs">
                                    {{ labels[1145] }}<!-- select -->
                                </button>
                                <small v-else>
                                    {{ labels[1382] }}<!--label: selected -->
                                </small>
                            </td>
                        </tr>
                    </template>
                    <tr v-else id="0" class="highlight">
                        <td>
                            {{ labels[1144] }}
                        </td>
                        <td></td>
                        <td>
                            {{ labels[1382] }} <!--label: selected -->
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="hide" id="sel-button-vue">
                <button type="button" class="btn btn-default btn-xs">{{ labels[1145] }}<!-- select --></button>
            </div>
            <div class="hide" id="sel-text-vue">
                <small>{{ labels[1382] }} <!--label: selected --></small>
            </div>
        </div>

    </div>
</template>

<script>
import useCMS from "../../shared/composables/useCMS"
import useCheckout from "../composables/useCheckout"
import useUtils from "../../shared/composables/useUtils"
import useCheckoutAddresses from "../composables/useCheckoutAddresses"
import { computed } from '@vue/composition-api'

export default {
    name: 'CheckoutAddressOptions',
    props: {
        addressOptions: Array,
        addressCount: Number,
        mode: String //default shipping
    },
    setup (props) {
        const { labels } = useCMS();
        const { addresses } = useCheckout();
        const { breakCharsToBr } = useUtils();
        const { selectAddress, loadingAddresses } = useCheckoutAddresses();

        const isSelected = (optionId) =>  (optionId == addresses.value[props.mode].ID);
        const isHighlighted = (optionId) => isSelected(optionId) ? 'highlight': '';
        const isAddressSameAsShipping = (optionId) => addresses.value.shipping.ID === optionId;

        const isLoadingAddresses = computed(() => loadingAddresses.value)

        return {
            labels,
            breakCharsToBr,
            selectAddress,
            isSelected,
            isHighlighted,
            addresses,
            isAddressSameAsShipping,
            isLoadingAddresses
        }
    }
}


</script>
